import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../config/site';
import { imageUrl } from '../services/api';

export default function Hero({ featuredProducts = [] }) {
  const [slide, setSlide] = useState(0);
  const banners = SITE.banners;

  useEffect(() => {
    const t = setInterval(() => setSlide((s) => (s + 1) % banners.length), 6500);
    return () => clearInterval(t);
  }, [banners.length]);

  const current = banners[slide];
  const bgProduct = featuredProducts.find((p) => (p.subcategoria || '') === current.category)
    || featuredProducts[slide % Math.max(featuredProducts.length, 1)];
  const bgImage = bgProduct ? imageUrl(bgProduct.imagen) : '';

  const shopTo =
    current.category === 'Todas'
      ? '/catalogo'
      : `/catalogo?cat=${encodeURIComponent(current.category)}`;

  return (
    <section className="hero">
      <div className="hero-bg" style={bgImage ? { backgroundImage: `url(${bgImage})` } : undefined} />
      <div className="hero-veil" />

      <button
        type="button"
        className="hero-arrow prev"
        onClick={() => setSlide((s) => (s - 1 + banners.length) % banners.length)}
        aria-label="Anterior"
      >
        ‹
      </button>
      <button
        type="button"
        className="hero-arrow next"
        onClick={() => setSlide((s) => (s + 1) % banners.length)}
        aria-label="Siguiente"
      >
        ›
      </button>

      <div className="hero-inner">
        <div className="hero-copy" key={current.title}>
          <h1 className="hero-title" data-text={current.title}>
            {current.title}
          </h1>
          <Link to={shopTo} className="hero-pill">
            {current.subtitle}
          </Link>
          <p className="hero-handle">{SITE.handle}</p>
          <Link to={shopTo} className="hero-cta-link">
            {current.cta} →
          </Link>
        </div>
      </div>

      <div className="hero-dots">
        {banners.map((_, i) => (
          <button
            key={i}
            type="button"
            className={i === slide ? 'active' : ''}
            onClick={() => setSlide(i)}
            aria-label={`Banner ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
